import { api } from 'services/companiesApi';

export const getProgressDetails = (id: string, filters?: string) =>
	api.get(`campaigns/${id}/company-progress`, {
		params: filters,
	});
